<template>
  <!-- eslint-disable -->
  <div>
    <!-- <formulario-filters /> -->
    <validation-observer ref="movExterForm" #default="{ invalid }">
      <b-row>
        <b-col md="2" class="mb-md-0 mb-2">
          <b-form-group label="Tipo" label-for="action_type">
            <validation-provider #default="{ errors }" name="form.action_type" vid="action_type" rules="requeridoE">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="Types"
                label="name"
                v-model="form.action_type"
                :reduce="(Types) => Types.val"
                input-id="action_type"
                @input="typeAction(form.action_type)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="3" class="mb-md-0 mb-2">
          <b-form-group label="Tienda Origen" label-for="storeSelected">
            <validation-provider #default="{ errors }" name="form.storeSelected" vid="storeSelected" rules="requeridoE">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="locals"
                label="name"
                v-model="form.storeSelected"
                :reduce="(locals) => locals.id"
                input-id="storeSelected"
                @input="searchMov(form.storeSelected)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="2" class="mb-md-0 mb-2">
          <b-form-group label="Tipo Documento" label-for="tipo">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="tipoCompro"
              label="text"
              :reduce="(tipoCompro) => tipoCompro.val"
              input-id="tipo"
              v-model="form.document_type"
            />
          </b-form-group>
        </b-col>
        <b-col md="3" class="mb-md-0 mb-2">
          <b-form-group label="Nro Documento" label-for="description">
            <b-form-input
              id="description"
              placeholder="Nro Documento"
              autofocus
              trim
              v-model="form.documentDescription"
              @keypress="onlyNumbers($event)"
            />
          </b-form-group>
        </b-col>

        <b-col md="2" class="mb-md-0 mb-2 d-flex align-items-center justify-content-end w-100" v-if="items.length > 0">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger" @click.prevent="register">
            Registrar
          </b-button>
        </b-col>
      </b-row>
      <b-card no-body class="mb-0 mt-2" v-if="items.length > 0">
        <b-row>
          <b-col md="3">
            <b-form-group label="Extra Descripción">
              <b-form-textarea
                id="extradescription"
                placeholder="Extra Descripción"
                no-resize
                trim
                v-model="form.extendedDescription"
                rows="3"
              />
            </b-form-group>
          </b-col>
          <b-col md="9" class="mb-3">
            <b-table
              class="position-relative border border-2 rounded mt-2"
              :hover="true"
              :items="items"
              responsive
              :fields="fieldsItems"
              show-empty
              empty-text="No existen"
              @sort-changed="sortChanged"
            >
              <template v-slot:cell(cantidad)="{ item,index, field: { key } }">
                <b-input-group>
                  <validation-provider
                    #default="{ errors }"
                    name="form.cantidad"
                    vid="form.cantidad"
                    rules="requeridoE"
                  >
                    <b-form-input
                      v-model="item[key]"
                      style="width: 150px"
                      @input="limitStock(item, index, item[key])"
                      type="number"
                      @keypress="onlyNumbers($event)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-input-group>
              </template>
              <template v-slot:cell(precio)="{ item, field: { key } }">
                <b-input-group>
                  <validation-provider
                    #default="{ errors }"
                    name="form.price"
                    vid="form.price"
                    rules="requeridoE"
                  >
                    <b-form-input
                      v-model="item[key]"
                      style="width: 150px"
                      type="number"
                      @keypress="onlyNumbers($event)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-input-group>
              </template>
              <template #cell(actions)="data">
                <b-button size="sm" class="" v-b-tooltip.hover.top="'Eliminar'" variant="flat-danger">
                  <feather-icon icon="Trash2Icon" />
                </b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-card>
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative border border-2 rounded"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
          :head-variant="'dark'"
          ref="table"
        >
          <template #cell(precio)="data">
            {{ '$' + data.value }}
          </template>
          <!-- Column: Actions -->
          <!-- <template #cell(actions)="data">
          <b-button size="sm" class="" v-b-tooltip.hover.top="'Detalle'" variant="flat-success">
            <feather-icon icon="EyeIcon" />
          </b-button>
        </template> -->
          <template #cell(actions)="data">
            <b-form-checkbox v-model="data.value" class="vs-checkbox-con" @change="selectItem(data.item, data.value)">
            </b-form-checkbox>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </validation-observer>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, requeridoE, email } from '@validations'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import StoreService from '@/services/StoresService'
import AutoPartsService from '@/services/AutoParts'
import StockService from '@/services/StockService'
import ExternalMovement from '@/services/ExternalMovement'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      required,
      showLoading: false,
      form: {
        document_type: '',
        documentDescription: '',
        extendedDescription: '',
        storeSelected: null,
        action_type: '',
        details: []
      },
      locals: [],
      tipoCompro: [
        {
          id: 1,
          text: 'Boleta',
          val: 'boleta'
        },
        {
          id: 2,
          text: 'Factura',
          val: 'factura'
        },
        {
          id: 3,
          text: 'Guia Remision',
          val: 'guia_remision'
        },
        {
          id: 4,
          text: 'Nota de Credito',
          val: 'nota_credito'
        },
        {
          id: 5,
          text: 'Devolución',
          val: 'devolucion'
        },
        {
          id: 6,
          text: 'Ninguno',
          val: ''
        }
      ],
      records: [],
      Types: [
        {
          id: 1,
          name: 'Compra',
          val: 'purchase'
        },
        {
          id: 2,
          name: 'Venta',
          val: 'sale'
        },
        {
          id: 3,
          name: 'Prestamo',
          val: 'lending'
        },
        {
          id: 4,
          name: 'Credito',
          val: 'credit'
        },
        {
          id: 5,
          name: 'Reembolso',
          val: 'refund'
        }
      ],
      fields: [
        // { key: 'id', label: 'Nº', sortable: false },
        { key: 'originalCode', label: 'Codigo Original', sortable: true },
        { key: 'alterCode', label: 'Codigo Alter.', sortable: true },
        { key: 'description', label: 'Descripción', sortable: false },
        { key: 'autopartBrand.name', label: 'Marca', sortable: true },
        { key: 'vehicleModel.model', label: 'Vehiculo', sortable: true },
        { key: 'retailPrice', label: 'Precio x Menor (US$)', sortable: false },
        { key: 'wholesalePrice', label: 'Precio x Mayor (US$)', sortable: false },
        { key: 'actions', label: 'Seleccionar' }
      ],
      fieldsItems: [
        { key: 'id', label: 'Nº', sortable: false },
        { key: 'originalCode', label: 'Código', sortable: false },
        { key: 'qty_available', label: 'Cantidad Disp.', sortable: false },
        { key: 'cantidad', label: 'Cantidad', sortable: false },
        { key: 'precio', label: 'Precio', sortable: false },
        { key: 'actions', label: 'Acciones' }
      ],
      idStore: null,
      items: [],
      cont: 1,
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'desc'
    }
  },
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver
  },
  mounted() {
    this.getData()
  },
  methods: {
    limitStock(item, index, val) {
      console.log('this.items.length',this.items.length)
      if (this.items.length != 0) {
        this.$watch(
        'items',
        function () {
          if (this.items.length > 0) {
            this.items[index].cantidad =
            this.items[index].cantidad > item.qty_available ? item.qty_available : this.items[index].cantidad
          }          
        },
        { deep: true }
      )
      }      
    },
    async getData() {
      const resp = await StoreService.getStores('',this.$store)
      if (resp) {
        this.locals = resp.stores
      }
    },
    onlyNumbers(e) {
      if ((e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode == 46) {
        return true
      } else {
        e.preventDefault()
      }
    },
    resetForm() {
      this.items = []
      this.form = {
        document_type: '',
        documentDescription: '',
        extendedDescription: '',
        storeSelected: null,
        action_type: '',
        details: []
      }
      this.records = []
      this.$refs.movExterForm.reset()
    },
    register() {
      this.$refs.movExterForm.validate().then(async (success) => {
        this.form.details = []
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index]
          this.form.details.push({
            autopart: element.id,
            qty: parseInt(element.cantidad),
            price: parseFloat(element.precio)
          })
        }
        console.log('this.form', this.form)
        const resp = await ExternalMovement.saveMovements(this.form, this.$store)
        console.log('resp', resp)
        if (resp) {
          this.$swal({
            title: 'Añadido',
            text: 'El movimiento ha sido registrado',
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-primary'
            },
            buttonsStyling: false
          })
          this.isDisabled = false
          this.resetForm()
        }
      })
    },
    cambioPagina(e) {
      this.currentPage = e
      if (this.form.action_type != 'purchase') {
        this.searchMov(this.idStore)
      } else {
        this.action_type(this.form.action_type)
      }
      
    },
    onlyNumbers(e) {
      if ((e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode == 46) {
        return true
      } else {
        e.preventDefault()
      }
    },
    selectItem(item, val) {
      if (val == true) {
        this.items.push(item)
      } else {
        const index = this.records.findIndex((elemento) => elemento.id == item.id)
        this.records[index].value = false
        this.items = this.items.filter((elemento) => elemento.id !== item.id)

        // this.items = this.items.filter((item) => item.id != item.id)
      }
      console.log('this.items', this.items)
    },
    async typeAction(tipo) {
      if (tipo == 'purchase') {
        this.records = []
        this.items = []
        let offset = this.showEntrie*(this.currentPage-1)  
        const url = `?limit=${this.showEntrie}&offset=${offset}`
        const resp = await AutoPartsService.getAutoParts(url,this.$store)
        if (resp.autoparts.length != 0) {
          this.totalElements = resp.itemCount
          for (let index = 0; index < resp.autoparts.length; index++) {
            const element = resp.autoparts[index]
            this.records[index] = element
          }
          this.$refs.table.refresh()
        }
      } else {
        this.items = []
        if (this.form.storeSelected != null) {
          this.searchMov(this.form.storeSelected)
        } else {
          this.records = []
          this.$refs.table.refresh()
        }
      }
    },
    async searchMov(id) {
      if (this.form.action_type != 'purchase') {
        this.idStore = id
        this.items = []
        this.records = []
        let offset = this.showEntrie*(this.currentPage-1)  
        const url = `?limit=${this.showEntrie}&offset=${offset}&filter=${id}`
        const resp = await StockService.getMovements(url, this.$store)
        console.log('resp de tienda', resp)
        if (resp.stocks.length != 0) {
          this.totalElements = resp.itemCount
          for (let index = 0; index < resp.stocks.length; index++) {
            const element = resp.stocks[index]
            this.records[index] = element.autopart
            this.records[index].qty_available = element.qty_available
          }
          this.$refs.table.refresh()
        }
      }
    },
    changeSizePage() {
      if (this.form.action_type != 'purchase') {
        this.searchMov(this.idStore)
      } else {
        this.action_type(this.form.action_type)
      }
    },
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
